module.exports = __webpack_public_path__ + "img/1.140688c8.png";